'use client';

import * as React from 'react';
import {
  BarChart3Icon,
  TrendingUpIcon,
  TargetIcon,
  DollarSignIcon,
  CalendarIcon,
  PieChartIcon
} from 'lucide-react';

import { BlurFade } from '~/components/fragments/blur-fade';
import { GridSection } from '~/components/fragments/grid-section';
import { SiteHeading } from '~/components/fragments/site-heading';

const FEATURES = [
  {
    icon: <BarChart3Icon className="size-5 shrink-0" />,
    title: 'Omzetanalyse',
    description:
      'Krijg gedetailleerde inzichten in je omzet met real-time dashboards. Analyseer trends, vergelijk periodes en identificeer groeikansen.'
  },
  {
    icon: <TrendingUpIcon className="size-5 shrink-0" />,
    title: 'Omzetprognoses',
    description:
      'Voorspel toekomstige inkomsten op basis van je pipeline en historische data. Plan beter en stel realistische doelen met data-gedreven voorspellingen.'
  },
  {
    icon: <TargetIcon className="size-5 shrink-0" />,
    title: 'Doelstellingen bijhouden',
    description:
      'Stel omzetdoelen in en volg je voortgang in real-time. Zie precies waar je staat ten opzichte van je doelen en wat er nog nodig is.'
  },
  {
    icon: <DollarSignIcon className="size-5 shrink-0" />,
    title: 'Openstaande bedragen',
    description:
      'Houd overzicht over alle openstaande facturen en verwachte betalingen. Zie in één oogopslag wat er nog binnen moet komen en wanneer.'
  },
  {
    icon: <CalendarIcon className="size-5 shrink-0" />,
    title: 'Cashflow voorspelling',
    description:
      'Plan je cashflow met voorspellingen op basis van verwachte betalingen en uitgaven. Zo voorkom je verrassingen en houd je controle.'
  },
  {
    icon: <PieChartIcon className="size-5 shrink-0" />,
    title: 'Rapportages',
    description:
      'Genereer uitgebreide rapportages over je financiële prestaties. Exporteer data voor je boekhouder of gebruik het voor strategische beslissingen.'
  }
];

export function RevenueHubFeatures(): React.JSX.Element {
  return (
    <GridSection>
      <div className="container space-y-12 py-20 md:py-32">
        <SiteHeading
          badge="Unieke voordelen"
          title="Wat maakt Emma's Revenue Hub anders?"
          description="Ontdek de krachtige functies die Emma biedt om je financiële prestaties te analyseren en je omzet te maximaliseren."
        />

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <BlurFade
              key={index}
              inView
              delay={0.1 + index * 0.1}
              className="rounded-xl border bg-card p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="mb-4 flex size-12 items-center justify-center rounded-xl border bg-background text-primary">
                {feature.icon}
              </div>
              <h3 className="mb-2 text-lg font-semibold">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </BlurFade>
          ))}
        </div>
      </div>
    </GridSection>
  );
}
